import React from 'react'
import { Dispatch } from 'redux'
import { Formik } from 'formik'
import { IMediaType } from '../../types/mediaType'
import { createMediaType } from '../../actions/mediaType'
import { push } from '../../actions/router'
import { initialState } from '../../reducers/mediaType'
import { mediaTypeValidationSchema } from '../MediaTypeForm/validation'
import { NavigationGuard } from '../../components'
import MediaTypeForm from '../MediaTypeForm'

export interface ICreateMediaTypeForm {
  mediaType: IMediaType
  dispatch: Dispatch
}

export const CreateMediaTypeForm = ({
  mediaType,
  dispatch,
}: ICreateMediaTypeForm) =>
  !mediaType.isLoading ? (
    <Formik
      initialValues={{ ...initialState }}
      enableReinitialize={true}
      onSubmit={(values) => {
        dispatch(createMediaType(values))
      }}
      render={(formikProps) => (
        <>
          <MediaTypeForm
            formikProps={formikProps}
            submitText="Create New Media Type"
            cancelAction={() => {
              formikProps.resetForm()
              dispatch(push('/settings/media-types?tab=all-types'))
            }}
          />
          <NavigationGuard isBlocking={formikProps.dirty} />
        </>
      )}
      validationSchema={mediaTypeValidationSchema}
    />
  ) : null
